export const phaseNames: string[] = [
  "Initiation Phase",
  "Scoping Phase",
  "Design Phase",
  "Prerequisites Phase",
  "Scheduling Phase",
  "Construction Phase",
  "Posting Phase",
];

export const stateNames: string[] = ["AT RISK", "ON TIME", "CRITICAL"];
